<template>
    <div class="set-coach">
        <button-tooltip v-if="libraryCoach" :tooltip="$t('company.change_coach')">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-on="on" v-bind="attrs" depressed height="36" class="set-coach-btn"
                    @click="showSelectCoach">
                    <v-icon size="17" class="set-coach-btn__icon">mdi-account-cog</v-icon>
                    <span class="set-coach-btn__label">{{ libraryCoach.name }}</span>
                </v-btn>
            </template>
        </button-tooltip>

        <set-coach-dialog ref="setCoach" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SetCoachDialog from '@/components/company/SetCoachDialog'
import ButtonTooltip from '@/components/common/ButtonTooltip'
import { EventBus } from '@/utils/EventBus'

export default {
    name: 'SetCoach',
    components: {
        SetCoachDialog,
        ButtonTooltip,
    },
    computed: {
        ...mapState(['libraryCoach']),
    },
    mounted() {
        EventBus.$on('company:select-coach', this.showSelectCoach)
    },
    beforeDestroy() {
        EventBus.$off('company:select-coach', this.showSelectCoach)
    },
    methods: {
        showSelectCoach() {
            const vm = this
            vm.$refs.setCoach.show()
        }
    },
}
</script>

<style scoped>
.set-coach-btn {
    margin-right: 12px;
    border-radius: 10px !important;
    border: 1px solid var(--v-outline2-base);
    background: var(--v-surface-base) !important;
    text-transform: none;
    letter-spacing: 0;
    font-size: var(--fs-label);
    font-weight: 600;
    color: var(--v-txtPrimary-base) !important;
    max-width: 220px;
}

.set-coach-btn__icon {
    margin-right: 6px;
    color: var(--v-txtSecondary-base);
}

.set-coach-btn__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

@media (max-width: 599px) {
    .set-coach-btn {
        min-width: 36px !important;
        padding: 0 10px !important;
    }

    .set-coach-btn__label {
        display: none;
    }

    .set-coach-btn__icon {
        margin-right: 0;
    }
}
</style>
